import { useContext } from "react";
import { ColorContext, WindowContext } from "../App.js";
import Close from "../images/close.svg";
import { useTranslation } from "react-i18next";

import Configuration from "./Configuration";
import Colors from "./Colors/Colors";

import Window2Lanes2Wings from "./Windows/Window2Lanes2Wings";

function UserInterface(props) {
  const { t } = useTranslation();
  const { currentWindow } = useContext(WindowContext);
  const { currentColor, setCurrentColor } = useContext(ColorContext);

  const updateMaterialColor = function (color) {
    setCurrentColor(color);
  };

  return (
    <div id="panel" className={`panel-${props.documentDirection}`}>
      <div className="window-panel">
        <div id="top-panel">
          <button id="btn-close-panel">
            <img src={Close} alt={t("alt_close_button")}></img>
          </button>
        </div>
        <Configuration />
        <Colors setCurrentColor={(color) => updateMaterialColor(color)} />
        {currentWindow === "2w" ? <Window2Lanes2Wings /> : null}
      </div>
    </div>
  );
}

export default UserInterface;
